import useRouterState from '@discover-use-router-state';
import { FavouriteModelValue } from '@discover-data/stores/restaurant/model/favourite/model';
import { useStoreActions, useStoreState } from '@discover-data/stores/restaurant/hooks';
import DEFAULT_FAVOURITE from '@discover-data/stores/restaurant/model/favourite/default';
import usePage from '@discover-data/stores/hooks/page/usePage';
import FAVOURITE_QUERY_KEY from './queryKey';

export default function useFavourite(
  userFavouriteIds: (number | null)[] | null | undefined
): [FavouriteModelValue, (newFavourite: boolean) => void] {
  const favouriteIds = (userFavouriteIds || []).filter((id) => id !== null);
  const storeMode = useStoreState((state) => state.mode);
  const value = useStoreState((state) => state.favourite.value);
  const setStoreValue = useStoreActions((actions) => actions.favourite.set);
  const [, setRouterValues] = useRouterState([FAVOURITE_QUERY_KEY]);
  const { resetPage } = usePage();

  function set(newValue: boolean) {
    resetPage();

    setStoreValue(newValue ? favouriteIds : DEFAULT_FAVOURITE);

    const newRouterValues = newValue !== DEFAULT_FAVOURITE ? [`${newValue}`] : [];
    setRouterValues({ [FAVOURITE_QUERY_KEY]: newRouterValues });
  }

  return [value, set];
}
